import { Config } from "../services/Config"
import { ServiceManager, ServiceType } from "../services/ServiceManager";
import { IGeocoder } from "../services/Geocoders/IGeocoder";
import Coordinate from "./Coordinate";
import { Logger, LogLevel } from "../services/Logger";

class MapMarker {
  public Coordinate?: Coordinate;
  public Address?: string;
  public Content?: string;
  public IconURL?: string;
  public Title?: string;

  constructor(init?: Partial<MapMarker>) {
    if (init) Object.assign(this, init);
  }
}

class MapSettings {
  public Zoom: number = 13;
  public Markers: MapMarker[] = [];
  public Center?: Coordinate;

  public readonly ProviderConfig = Config.Website.Settings!.MapProvider;

  constructor(init?: Partial<MapSettings>) {
    if (init) Object.assign(this, init);
  }

  async Geocode(): Promise<undefined> {
    var geocoderService = ServiceManager.Require<IGeocoder>(ServiceType.Geocoder);

    if (geocoderService == null) {
      Logger.Log(LogLevel.Warning, '[Geocoder]', 'No geocoder found.');
      return;
    }

    const geocodingRequests = this.Markers.filter((m) => m.Coordinate == undefined && m.Address != undefined).map(async (m) => {
      const result = await geocoderService.Geocode(m.Address!);

      m.Coordinate = result;
    });

    Logger.Log(LogLevel.Debug, '[Geocoder]', 'Geocoding', geocodingRequests);

    await Promise.all(geocodingRequests);
  }
}

export { MapMarker, MapSettings }
